var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('strong',[_vm._v("Custom 1 column backend layout")]),_vm._v(" "),_c('ce-renderer',{attrs:{"content":_vm.content.colPos0}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }